var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { Pressable, View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { Typography } from '../typography';
import { getInputOtpProps, getInputOtpStyles } from './InputOtpStyles';
import { OtpBoxes } from './components';
import { getTestId } from '../../utils';
export var InputOtp = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var inputOtpProps = getInputOtpProps(props, stateContext);
  var inputOtpStyles = getInputOtpStyles(inputOtpProps);
  var style = inputOtpProps.style,
    label = inputOtpProps.label,
    hintText = inputOtpProps.hintText,
    isActionableHint = inputOtpProps.isActionableHint,
    onActionableHintPressHandler = inputOtpProps.onActionableHintPressHandler,
    _inputOtpProps$testID = inputOtpProps.testID,
    testID = _inputOtpProps$testID === void 0 ? 'InputOtp' : _inputOtpProps$testID,
    restProps = __rest(inputOtpProps, ["style", "label", "hintText", "isActionableHint", "onActionableHintPressHandler", "testID"]);
  var inputHintFontType = isActionableHint ? 'body-hyperlink-xs' : 'body-para-xs';
  var onHintPressHandler = () => {
    isActionableHint && (onActionableHintPressHandler === null || onActionableHintPressHandler === void 0 ? void 0 : onActionableHintPressHandler());
  };
  var Wrapper = isActionableHint ? Pressable : View;
  return _jsxs(View, Object.assign({
    style: [inputOtpStyles.container, style]
  }, getTestId(testID), restProps, {
    children: [!!label && _jsx(Typography, Object.assign({
      type: "body-single-line-xs",
      style: inputOtpStyles.label,
      text: label
    }, getTestId(testID, 'label'))), _jsx(View, Object.assign({
      style: inputOtpStyles.otpBoxesContainer
    }, {
      children: _jsx(OtpBoxes, Object.assign({}, inputOtpProps, {
        ref: ref
      }, getTestId(testID, 'optBoxes')))
    })), !!hintText && _jsx(View, Object.assign({
      style: inputOtpStyles.hintContainer
    }, {
      children: !!hintText && _jsx(Wrapper, Object.assign({
        disabled: !isActionableHint,
        onPress: onHintPressHandler
      }, {
        children: _jsx(Typography, Object.assign({
          type: inputHintFontType,
          style: inputOtpStyles.hint,
          text: hintText
        }, getTestId(testID, 'hintText')))
      }))
    }))]
  }));
});